import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class DocumentRevisionsRequest extends GenericRequest {

    page;
    term;
    filter;
    document_type_id;

    constructor(id, page, term = '', filter = 0, document_type_id = null) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.DOCUMENT_REVISIONS, { id: id }));

        this.page = page;
        this.term = term;
        this.filter = filter;
        this.document_type_id = document_type_id;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) request.criteria.document_state_ids = [this.filter];
        if ( this.document_type_id ) request.criteria.document_type_ids = [this.document_type_id];
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/DocumentRevisionsRequest.js